export default "__VITE_ASSET__DARXoYOA__"